import { defineComponent, h } from 'vue';
import { QBtn, QIcon, QMenu, QTooltip } from 'quasar';
import BaseComponent from './BaseComponentMixin.jsx';
import utils from '../../Shared/utils.jsx';
import EventBus from '../event-bus.js';
import {
    iconAffixClasses,
    BUTTON_BORDER_CLASS,
    tooltipLocationToAnchorSelf,
    tooltipOffsetForPlacement,
    normalizeIconName,
} from '../../Shared/buttonAppearance.js';
import './css/BasicButton.css';

export default defineComponent({
    name: 'icon-popup-menu',
    components: { QBtn, QIcon, QMenu, QTooltip },
    mixins: [BaseComponent],
    data: function () {
        return {
            textrenderer: null,
            iconrenderer: null,
            iconpositioner: null,
            icongapeval: null,
            flipHorizontallyEval: null,
            flipVerticallyEval: null,
            borderEval: null,
            animationEval: null,
            colorEval: null,
            cssClassEval: null,
            captionrenderer: null,
            tooltiprenderer: null,
            tooltipLocationEval: null,
            popupMenuPlacementEval: null,
            popupMenuBackgroundColorEval: null,
            popupMenuFontColorEval: null,
            popupMenuWidthEval: null,
            popupMenuBodyPaddingEval: null,
            isDefaultEval: null,
            isdisabledeval: null,

            menushowing: false,
        };
    },
    computed: {
        text() {
            if (this.textrenderer === null)
                this.textrenderer = utils.compile(this, this.controlData.Text);
            return utils.evaluate(this.textrenderer, this);
        },
        icon() {
            if (this.iconrenderer === null)
                this.iconrenderer = utils.compile(this, this.controlData.Icon);
            return utils.evaluate(this.iconrenderer, this);
        },
        iconPosition() {
            if (this.iconpositioner === null && this.controlData.IconPosition)
                this.iconpositioner = utils.compile(this, this.controlData.IconPosition);
            if (this.iconpositioner)
                return utils.evaluate(this.iconpositioner, this);
            return 'right';
        },
        iconGap() {
            if (this.icongapeval === null && this.controlData.IconGap)
                this.icongapeval = utils.compile(this, this.controlData.IconGap);
            if (this.icongapeval)
                return utils.evaluate(this.icongapeval, this);
            return 10;
        },
        flipHorizontally() {
            if (this.flipHorizontallyEval === null && this.controlData.FlipHorizontally)
                this.flipHorizontallyEval = utils.compile(this, this.controlData.FlipHorizontally);
            if (this.flipHorizontallyEval)
                return utils.evaluate(this.flipHorizontallyEval, this);
            return false;
        },
        flipVertically() {
            if (this.flipVerticallyEval === null && this.controlData.FlipVertically)
                this.flipVerticallyEval = utils.compile(this, this.controlData.FlipVertically);
            if (this.flipVerticallyEval)
                return utils.evaluate(this.flipVerticallyEval, this);
            return false;
        },
        border() {
            if (this.borderEval === null && this.controlData.Border)
                this.borderEval = utils.compile(this, this.controlData.Border);
            if (this.borderEval)
                return utils.evaluate(this.borderEval, this);
            return false;
        },
        animation() {
            if (this.animationEval === null && this.controlData.Animation)
                this.animationEval = utils.compile(this, this.controlData.Animation);
            if (this.animationEval)
                return utils.evaluate(this.animationEval, this);
            return 'None';
        },
        color() {
            let theColor = 'secondary';
            if (this.colorEval === null && this.controlData.Color)
                this.colorEval = utils.compile(this, this.controlData.Color);
            if (this.colorEval)
                theColor = utils.evaluate(this.colorEval, this);

            if (this.isOutlined && theColor)
                theColor = theColor.replace('outline-', '');
            else
                theColor = theColor || 'secondary';

            // Keep backwards compatibility for older 'default' color values.
            return theColor === 'default' ? 'secondary' : theColor;
        },
        cssClass() {
            if (this.cssClassEval === null && this.controlData.CssClass)
                this.cssClassEval = utils.compile(this, this.controlData.CssClass);
            if (this.cssClassEval)
                return utils.evaluate(this.cssClassEval, this);
            return '';
        },
        caption() {
            if (this.captionrenderer === null && this.controlData.Caption)
                this.captionrenderer = utils.compile(this, this.Translate(this.controlData.Caption));
            if (this.captionrenderer)
                return utils.evaluate(this.captionrenderer, this);
            return '';
        },
        tooltip() {
            if (this.tooltiprenderer === null && this.controlData.Tooltip)
                this.tooltiprenderer = utils.compile(this, this.Translate(this.controlData.Tooltip));
            if (this.tooltiprenderer)
                return utils.evaluate(this.tooltiprenderer, this);
            return '';
        },
        tooltipLocation() {
            let location = '';
            if (this.tooltipLocationEval === null && this.controlData.TooltipLocation)
                this.tooltipLocationEval = utils.compile(this, this.controlData.TooltipLocation);
            if (this.tooltipLocationEval)
                location = utils.evaluate(this.tooltipLocationEval, this);

            return location == null || location === '' ? 'top' : String(location);
        },
        popupMenuPlacement() {
            if (this.popupMenuPlacementEval === null && this.controlData.PopupMenuPlacement)
                this.popupMenuPlacementEval = utils.compile(this, this.controlData.PopupMenuPlacement);
            if (this.popupMenuPlacementEval)
                return utils.evaluate(this.popupMenuPlacementEval, this);
            return 'bottom';
        },
        popupMenuBackgroundColor() {
            if (this.popupMenuBackgroundColorEval === null && this.controlData.PopupMenuBackgroundColor)
                this.popupMenuBackgroundColorEval = utils.compile(this, this.controlData.PopupMenuBackgroundColor);
            if (this.popupMenuBackgroundColorEval)
                return utils.evaluate(this.popupMenuBackgroundColorEval, this);
            return '';
        },
        popupMenuFontColor() {
            if (this.popupMenuFontColorEval === null && this.controlData.PopupMenuFontColor)
                this.popupMenuFontColorEval = utils.compile(this, this.controlData.PopupMenuFontColor);
            if (this.popupMenuFontColorEval)
                return utils.evaluate(this.popupMenuFontColorEval, this);
            return '';
        },
        popupMenuWidth() {
            if (this.popupMenuWidthEval === null && this.controlData.PopupMenuWidth)
                this.popupMenuWidthEval = utils.compile(this, this.controlData.PopupMenuWidth);
            if (this.popupMenuWidthEval)
                return utils.evaluate(this.popupMenuWidthEval, this);
            return '';
        },
        popupMenuBodyPadding() {
            if (this.popupMenuBodyPaddingEval === null && this.controlData.PopupMenuBodyPadding)
                this.popupMenuBodyPaddingEval = utils.compile(this, this.controlData.PopupMenuBodyPadding);
            if (this.popupMenuBodyPaddingEval)
                return utils.evaluate(this.popupMenuBodyPaddingEval, this);
            return '';
        },
        isDefault() {
            if (this.isDefaultEval === null && this.controlData.IsDefault)
                this.isDefaultEval = utils.compile(this, this.controlData.IsDefault);
            if (this.isDefaultEval)
                return utils.evaluate(this.isDefaultEval, this);
            return false;
        },
        isdisabled() {
            if (this.isdisabledeval === null && this.controlData.IsDisabled)
                this.isdisabledeval = utils.compile(this, this.controlData.IsDisabled);
            if (this.isdisabledeval)
                return utils.evaluate(this.isdisabledeval, this);
            return false;
        },
        isOutlined() {
            return this.controlData.Color && this.controlData.Color.startsWith('outline-');
        },
        buttonClasses() {
            const classes = {
                ThemeRightConnector: this.themes.rightConnector,
                ThemeLeftConnector: this.themes.leftConnector
            };

            if (this.cssClass)
                classes[this.cssClass] = true;

            const outlined = this.isOutlined || this.themes.condensedBordered;
            if (this.border && !outlined)
                classes[BUTTON_BORDER_CLASS] = true;

            return classes;
        },
        iconClasses() {
            return iconAffixClasses({
                flipH: !!this.flipHorizontally,
                flipV: !!this.flipVertically,
                animation: this.animation,
            });
        },
        themes() {
            return {
                flat: this.controlData.Themes ? this.controlData.Themes.includes('Flat') || this.controlData.Themes.includes('FlatWhite') || this.controlData.Themes.includes('Transparent') : false,
                small: this.controlData.Themes ? this.controlData.Themes.includes('Condensed') || this.controlData.Themes.includes('CondensedBordered') : false,
                condensedBordered: this.controlData.Themes ? this.controlData.Themes.includes('CondensedBordered') : false,
                transparent: this.controlData.Themes ? this.controlData.Themes.includes('Transparent') : false,
                leftConnector: this.controlData.Themes ? this.controlData.Themes.includes('LeftConnector') : false,
                rightConnector: this.controlData.Themes ? this.controlData.Themes.includes('RightConnector') : false,
                floatingAction: this.controlData.Themes ? this.controlData.Themes.includes('FloatingAction') : false,
            };
        },
        styles() {
            return {
                ...this.sizeStyle,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                ...utils.resolveStyleHints(this.styleHints, this),
            };
        },
        menuAnchor() {
            const placement = (this.popupMenuPlacement || 'bottom').toLowerCase();
            if (placement === 'top') return 'top middle';
            if (placement === 'left') return 'center left';
            if (placement === 'right') return 'center right';
            return 'bottom middle';
        },
        menuSelf() {
            const placement = (this.popupMenuPlacement || 'bottom').toLowerCase();
            if (placement === 'top') return 'bottom middle';
            if (placement === 'left') return 'center right';
            if (placement === 'right') return 'center left';
            return 'top middle';
        },
        isDisabledBool() {
            return this.isdisabled === true || this.isdisabled === 'true';
        },
    },
    created() {
        this.$on('Action-Close', this.performClose);

        if (this.controlData.Name) {
            this.$on(`Action-Close:${this.controlData.Name}`, this.performClose);
            EventBus.$on(`Action-Close:${this.controlData.Name}`, this.performClose);
        }
    },
    methods: {
        preRenderComplete() {
            this.finishRenderHandler(this);
        },
        async performClose(action) {
            utils.log(' ** Close Action Received by BasicPopupMenu **');
            this.menushowing = false;

            try {
                await utils.success(action);
            } catch (e) { }

            action.FinishFunc(true);
        },
        async doClick(e) {
            e.cancelBubble = true;
            e.stopPropagation();

            if (this.controlData.Actions && this.controlData.Actions.length)
                await utils.executeAndCompileAllActions(this.controlData.Actions, null, this);
        },
    },
    props: {},
    render() {
        try {
            if (!this.todisplay)
                return null;

            const content = [];
            const iconName = normalizeIconName(this.icon, { iconStyle: this.controlData?.IconStyle });
            const iconSize = this.themes.small ? '16px' : '20px';
            const popupIconGap = this.controlData.PopupMenuTitle?.IconGap || 8;

            if (this.text && iconName) {
                const pos = (this.iconPosition || '').toLowerCase();
                if (pos === 'left')
                    content.push(<QIcon name={iconName} style={{ marginRight: this.iconGap + 'px' }} size={iconSize} class={this.iconClasses} />);
                content.push(this.text);
                if (!pos || pos === 'right')
                    content.push(<QIcon name={iconName} style={{ marginLeft: this.iconGap + 'px' }} size={iconSize} class={this.iconClasses} />);
            }
            else if (this.text)
                content.push(this.text);
            else if (iconName)
                content.push(<QIcon name={iconName} class={this.iconClasses} size={iconSize} />);

            let menuContent = utils.generateItemsFromArray(h, this, this.controlData.Controls, null, 'BasicPopupMenu', {
                onFinishedRender: (reference) => this.finishRenderHandler(reference),
            });
            let titleContent = [];
            let title = null;

            if (this.controlData.PopupMenuTitle?.Text && this.controlData.PopupMenuTitle?.Icon) {
                const titleIconName = normalizeIconName(this.controlData.PopupMenuTitle.Icon, {
                    iconStyle: this.controlData?.IconStyle,
                });
                if (this.controlData.PopupMenuTitle?.IconPosition === 'Left')
                    titleContent.push(<QIcon name={titleIconName} style={{ marginRight: popupIconGap + 'px' }} />);
                titleContent.push(this.controlData.PopupMenuTitle.Text);
                if (!this.controlData.PopupMenuTitle?.IconPosition || this.controlData.PopupMenuTitle?.IconPosition === 'Right')
                    titleContent.push(<QIcon name={titleIconName} style={{ marginLeft: popupIconGap + 'px' }} />);
            }
            else if (this.controlData.PopupMenuTitle?.Text)
                titleContent.push(this.controlData.PopupMenuTitle.Text);
            else if (this.controlData.PopupMenuTitle?.Icon)
                titleContent.push(
                    <QIcon
                        name={normalizeIconName(this.controlData.PopupMenuTitle.Icon, {
                            iconStyle: this.controlData?.IconStyle,
                        })}
                    />
                );

            if (titleContent.length)
                title = <div style={{ borderBottom: '1px solid #46465a', fontWeight: 'bold', padding: '8px' }}>{titleContent}</div>;

            let tooltip;
            if (this.tooltip) {
                const { anchor, self } = tooltipLocationToAnchorSelf(this.tooltipLocation);
                const offset = tooltipOffsetForPlacement(this.tooltipLocation);
                tooltip = (
                    <QTooltip
                        transition-show="scale"
                        transition-hide="scale"
                        anchor={anchor}
                        self={self}
                        {...(offset !== undefined ? { offset } : {})}
                    >
                        {utils.renderTooltipContent(this.tooltip)}
                    </QTooltip>
                );
            }

            const fab = this.themes.floatingAction;
            // FAB can coexist with Flat/FlatWhite/Transparent (flat/unelevated) and Condensed (dense)
            const flatAppearance = !fab || this.themes.flat;
            let button = (
                <QBtn
                    class={this.buttonClasses}
                    color={this.color}
                    outline={this.isOutlined || this.themes.condensedBordered}
                    unelevated={this.themes.flat}
                    flat={flatAppearance}
                    fab={fab}
                    round={fab}
                    dense={!fab || this.themes.small}
                    onClick={(e) => this.doClick(e)}
                    type="button"
                    disable={this.isDisabledBool}
                    is-default={this.isDefault}
                    stretch={this.sizeOptions && this.sizeOptions.Width && this.sizeOptions.Width.Mode === 'Fill'}
                    noCaps
                    stack={!!this.caption}
                    label={this.caption}
                    icon={iconName}
                >
                    <QMenu
                        class="c-BasicPopupMenu-menuHost"
                        xmodelValue={this.menushowing}
                        xonUpdate:modelValue={(value) => this.menushowing = value}
                        anchor={this.menuAnchor}
                        self={this.menuSelf}
                        disable={this.isDisabledBool}
                    >
                        <div style={{ backgroundColor: this.popupMenuBackgroundColor || undefined, width: this.popupMenuWidth || undefined }}>
                            {/* Default 0 so hover wash is edge-to-edge (CCDEV-17617). */}
                            <div class="column" style={{ padding: this.popupMenuBodyPadding || '0', color: this.popupMenuFontColor || undefined }}>
                                {title}
                                {menuContent}
                            </div>
                        </div>
                    </QMenu>
                    {tooltip}
                </QBtn>
            );

            //button = utils.generateTooltip(h, button, this.tooltip, this.tooltipLocation);

            return (
                <div
                    class={{ 'c-BasicPopupMenu': true, [`c-name-${this.name || 'unnamed'}`]: true, 'ma-1': true }}
                    v-show={this.isvisible}
                    style={this.styles}
                >
                    {button}
                </div>
            );
        }
        catch (e) {
            utils.error('BasicPopupMenu Render failed', e);
            return <div>BasicPopupMenu Failed to Render {e}</div>;
        }
    },
});